import React, { useEffect, useState, useMemo } from 'react'
import { Spin } from 'antd'
import qs from 'qs'
import { useNavigate } from 'react-router-dom'
import Modal from 'meinian-package/src/baseComponent/modal'
import request from 'meinian-package/src/utils/request'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { getIpadVh } from 'common/ipad'
import OperationView from './operationView'
import
InfoView,
{ IMAGE_DETAIL_TAB } from './infoView'
import Recommend from '../imageDetail/infoView/recommend'
import { ImageDetailContext } from './content'
import styles from './index.module.less'

export default ({
  visible,
  listLength,
  onChangeIndex,
  outerIndex,
  onChange,
  initWaterfall,
  initSubColls,
  onVisibleChange,
  onDeleteItem,
  sampleCode
}) => {
  return <Modal
    visible={visible}
    style={{ width: '100vw', height: '100vh', borderRadius: 0, overflow: 'hidden' }}
    hiddenCloseIcon
    className={styles.mnImageDetail}
    hiddenFooter
  >
    <DetailContent
      sampleCode={sampleCode}
      listLength={listLength}
      onChangeIndex={onChangeIndex}
      outerIndex={outerIndex}
      onChange={onChange}
      initWaterfall={initWaterfall}
      initSubColls={initSubColls}
      onVisibleChange={onVisibleChange}
      onDeleteItem={onDeleteItem}
      type="modal"
    />
  </Modal>
}

export type TQueryParams ={
  blogId: string,
  inspirationId:string|number,
  collectId:string,
}

export type TDetailContentProps = {
  outerIndex?:number,
  onChangeIndex?: (arg:number)=>void,
  listLength?:number,
  onChange?:any,
  sampleCode:any,
  initWaterfall?:any,
  initSubColls?:any,
  onVisibleChange?:any,
  onDeleteItem?:any,
  type?:string,
}

export const DetailContent = ({
  outerIndex = 0,
  onChangeIndex,
  listLength = 0,
  sampleCode,
  onChange,
  initWaterfall,
  initSubColls,
  onVisibleChange,
  onDeleteItem,
  type,
}:TDetailContentProps) => {
  const history = useNavigate()
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [imgInfoList, setImgInfoList] = useState<Array<any>>([])
  const [innerIndex, setInnerIndex] = useState<number>(0)
  const [currentImage, setCurrentImage] = useState<any>({})
  const [banOperation, setBanOperation] = useState<boolean>(false) // 禁止操作
  const [loading, setLoading] = useState<boolean>(false)
  const [tabValue, setTabValue] = useState<IMAGE_DETAIL_TAB>(IMAGE_DETAIL_TAB.INFO)
  const [boxIndex, setBoxIndex] = useState(0)

  const [commentTotal, setCommentTotal] = useState(0)

  const [isDraw, setIsDraw] = useState(false)
  const [isMove, setIsMove] = useState(false)
  const [isAnnotate, setIsAnnotate] = useState(false)
  const [activeNoteIndex, setActiveNoteIndex] = useState(0)
  const [notes, setNotes] = useState([])

  const isPage = type !== 'modal'

  const fetchImgsData = async () => {
    setLoading(true)
    const res:any = await request.get('/zhikuan/mn/sample/query-sample-detail', { params: { sampleCode } })
    if (res.imgUrlList.length > 0) {
      // 获取图片原始尺寸
      delete res.width
      delete res.height
      const convertList = res.imgUrlList.map(item => {
        return {
          ...res,
          imageId: item.id,
          width: item.width,
          height: item.height,
          mainUrl: item.mainUrl,
          annotationNum: item.annotationNum
        }
      })
      setCurrentImage({
        ...convertList[innerIndex],
      })
      setImgInfoList(convertList)
      setInnerIndex(0)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (currentImage.id) {
      fetchCommentTotal()
    }
  }, [currentImage.id])

  useEffect(() => {
    onInit()
  }, [sampleCode])

  const fetchCommentTotal = async () => {
    const res:any = await request.get('/zhikuan/ins/inspiration/exclude/count-user-comment', {
      params: {
        userId: currentImage?.createUserId,
        collectOrSampleId: currentImage?.id,
        type: 1,
      }
    })
    setCommentTotal(res)
  }

  const onInit = () => {
    fetchImgsData()
  }

  const onWrapInit = () => {
    initWaterfall?.()
    initSubColls?.()
  }

  const onKeyDown = (e) => {
    if (banOperation) {
      return
    }
    if (e.keyCode === 38 && imgInfoList[innerIndex - 1]) {
      onChangeInnerIndex(innerIndex - 1)
    }
    if (e.keyCode === 40 && imgInfoList[innerIndex + 1]) {
      onChangeInnerIndex(innerIndex + 1)
    }
    if (e.keyCode === 37 && outerIndex - 1 >= 0 && tabValue !== IMAGE_DETAIL_TAB.RECOMMEND) {
      setInnerIndex(0)
      onChangeIndex(outerIndex - 1)
    }
    if (e.keyCode === 39 && outerIndex + 1 < listLength && tabValue !== IMAGE_DETAIL_TAB.RECOMMEND) {
      setInnerIndex(0)
      onChangeIndex(outerIndex + 1)
    }
  }
  useEffect(() => {
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [imgInfoList, innerIndex, banOperation, tabValue])

  const onChangeInnerIndex = async (val) => {
    setInnerIndex(val)
    setCurrentImage(imgInfoList[val])
  }

  const onOuterChange = (val) => {
    setInnerIndex(0)
    onChangeIndex(val)
  }

  useEffect(() => {
    if (currentImage.mainUrl) {
      onInitNotes()
    }
  }, [currentImage])

  const fetchNotes = async () => {
    const res:any = await request.post('/zhikuan/annotation/get-inspiration-blog-annotation', {
      mainUrl: currentImage?.mainUrl,
      targetId: sampleCode,
      type: 1,
    })
    if (res.baseBlogAnnotationDTOList) {
      setNotes(res.baseBlogAnnotationDTOList
        .map(m => ({ ...m, confirm: true, width: currentImage.width, height: currentImage.height })))
    }
  }

  const onBanOperation = (val) => {
    setBanOperation(val)
  }
  const onBoxIndex = (val) => {
    setBoxIndex(val)
  }
  const onIsDraw = (val) => {
    setIsDraw(val)
  }
  const onIsMove = (val) => {
    setIsMove(val)
  }
  const onActiveNoteIndex = (val) => {
    setActiveNoteIndex(val)
  }
  const onIsAnnotate = (val) => {
    setIsAnnotate(val)
  }

  const onInitNotes = () => {
    fetchNotes()
  }

  useEffect(() => {
    if (query.commentId) {
      setTabValue(IMAGE_DETAIL_TAB.COMMENT)
    }
    if (query.postilId && currentImage?.mainUrl) {
      const _index = imgInfoList.findIndex((item) => item.id === query.postilId)
      if (_index !== -1) {
        setInnerIndex(_index)
      }
      setTabValue(IMAGE_DETAIL_TAB.ANNOTATION)
    }
  }, [])

  const [isShowRight, setIsShowRight] = useState(false)

  const onIsShowRight = (val) => {
    setIsShowRight(val)
  }

  const them: any = useMemo(() => ({
    tabValue,
    onTabChange: (val) => setTabValue(val),
    currentImage,
    onInit,
    onWrapInit,
    onChange,
    onBanOperation,
    onVisibleChange,
    boxIndex,
    onBoxIndex,
    onDeleteItem,
    //
    commentTotal,
    onInitCommentTotal: fetchCommentTotal,
    // 批注
    notes,
    setNotes,
    onInitNotes,
    isDraw,
    onIsDraw,
    isMove,
    onIsMove,
    activeNoteIndex,
    onActiveNoteIndex,
    isAnnotate,
    onIsAnnotate,
    isShowRight,
    onIsShowRight,
    isPage,
  }), [tabValue, currentImage, boxIndex, notes, isDraw, isMove, activeNoteIndex, isAnnotate, isPage, commentTotal, isShowRight])

  return <ImageDetailContext.Provider value={them}>
    <div
      className={classNames(styles.close, 'fill-grey-bg')}
      onClick={() => {
        if (!isPage) {
          onVisibleChange?.(false)
        } else {
          history('/home')
        }
      }}
    ><Icon type="m-guanbi" /></div>
    <div className={styles.mnImageDetailContent} style={{ height: getIpadVh() }}>
      <Spin spinning={loading}>
        <div className={styles.mnImageDetailContentWrap}>
          <OperationView
            innerIndex={innerIndex}
            imgInfoList={imgInfoList}
            currentImage={currentImage}
            setImgInfoList={setImgInfoList}
            onChangeInnerIndex={onChangeInnerIndex}
            onBanOperation={(val) => setBanOperation(val)}
            onInit={onInit}
            outerMaxLength={listLength}
            outerIndex={outerIndex}
            onOuterChange={onOuterChange}
            tabValue={tabValue}
            isAnnotate={isAnnotate}
            onIsAnnotate={onIsAnnotate}
          />
          <InfoView />
        </div>
      </Spin>
      {tabValue === IMAGE_DETAIL_TAB.RECOMMEND && <Recommend tabValue={tabValue} imgInfoList={imgInfoList} />}
    </div>
  </ImageDetailContext.Provider>
}
